import { IconCube, IconFocusCentered, IconLayoutDashboard, IconMoon, IconSun } from "@tabler/icons-react";
import { RibbonButton, RibbonNumber, RibbonSection, useFilePicker } from "@tredespace/ui/widgets";
import type { JSX } from "react";
import {
  BASE_DATUM_MAX_MM,
  BASE_DATUM_MIN_MM,
  BASE_DATUM_STEP_MM,
  setBaseDatum,
} from "../../state/datum/datum.actions.ts";
import { datumState } from "../../state/datum/datum.state.ts";
import { frameScaffold } from "../../state/engine/engine.actions.ts";
import { setHud } from "../../state/hud/hud.actions.ts";
import { resetPanels } from "../../state/layout/layout.actions.ts";
import { goToReference, importReference } from "../../state/reference/reference.actions.ts";
import { toggleTheme } from "../../state/theme/theme.actions.ts";
import { themeState } from "../../state/theme/theme.state.ts";
import { AboutButton } from "./AboutButton.tsx";

export function ViewSection(): JSX.Element {
  const { theme } = themeState.use();
  const { baseDatumMm } = datumState.use();
  const picker = useFilePicker(".glb,.gltf", (file) => {
    void importReference(file).then((result) => {
      if (result.error) {
        setHud(result.error.msg);
      }
    });
  });

  return (
    <RibbonSection title="View">
      {picker.element}
      <RibbonButton
        icon={<IconFocusCentered />}
        label="Fit"
        size="medium"
        onClick={frameScaffold}
        tooltip={
          "Frame the whole scaffold\n" +
          "Rotate: left-drag · Pan: right-drag or ⇧-drag\n" +
          "Zoom: wheel (toward the pointer)\n" +
          "Alt+click: orbit around that point"
        }
      />
      <RibbonButton
        icon={<IconCube />}
        label="Import GLB"
        size="medium"
        onClick={picker.open}
        tooltip="Import a reference model to build around"
      />
      <RibbonButton
        icon={<IconCube />}
        label="Go to model"
        size="medium"
        onClick={goToReference}
        tooltip="Frame the reference model"
      />
      <RibbonNumber
        label="Jack"
        unit="mm"
        size="medium"
        value={baseDatumMm}
        onChange={setBaseDatum}
        min={BASE_DATUM_MIN_MM}
        max={BASE_DATUM_MAX_MM}
        step={BASE_DATUM_STEP_MM}
      />
      <RibbonButton
        icon={<IconLayoutDashboard />}
        label="Reset panels"
        size="medium"
        onClick={resetPanels}
        tooltip="Put every panel back in its default place — brings back a panel you closed"
      />
      <AboutButton />
      <RibbonButton
        icon={theme === "dark" ? <IconSun /> : <IconMoon />}
        label={theme === "dark" ? "Light" : "Dark"}
        size="big"
        onClick={toggleTheme}
        tooltip="Switch between the light and dark theme"
      />
    </RibbonSection>
  );
}
